import { getNameByProductRoute } from "../../../../ProductBreadcrumbs/utils/containers/Breadcrumbs/ProductBreadcrumbs/utils/create-category-breadcrumb.js";
function createProductTypeBreadcrumb(pageRoutes, path = "", transformUrl) {
  const { name, url } = findProductTypeUrl(pageRoutes, path);
  return {
    name: name || "",
    url: url && transformUrl ? transformUrl(url) : url
  };
}
function findProductTypeUrl(pageRoutes, path) {
  const routesByPath = Object.entries(pageRoutes).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});
  const routes = getRouteSegmentsByPath(path);
  const productTypePath = routes.find((route) => route in routesByPath);
  return productTypePath ? { url: productTypePath, name: routesByPath[productTypePath] } : {};
}
function getRouteSegmentsByPath(path) {
  return path.split("/").slice(1).reduce(
    (prev, curr, index) => {
      const newPathSection = prev[index].concat(`/${curr}`);
      prev.push(newPathSection);
      return prev;
    },
    [""]
  ).slice(1).reverse();
}
const getProductTypeName = (breadcrumb, getLabel, page) => {
  const productTypeName = page && breadcrumb.url && getNameByProductRoute(breadcrumb.url, page);
  return productTypeName ? productTypeName : getLabel(`products.${breadcrumb.name?.toLowerCase()}`, {
    defaultValue: breadcrumb.name
  });
};
const capitalizeWords = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());
export {
  capitalizeWords,
  createProductTypeBreadcrumb,
  findProductTypeUrl,
  getProductTypeName,
  getRouteSegmentsByPath
};
//# sourceMappingURL=utils.js.map
